import { render, staticRenderFns } from "./MedicalInformation.vue?vue&type=template&id=9bb69504&scoped=true"
import script from "./MedicalInformation.vue?vue&type=script&lang=js"
export * from "./MedicalInformation.vue?vue&type=script&lang=js"
import style0 from "./MedicalInformation.vue?vue&type=style&index=0&id=9bb69504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb69504",
  null
  
)

export default component.exports